import React from 'react';
import { FaFileCsv } from 'react-icons/fa';
import CargasFuente from '../../components/InversionesExterior/CargasFuente';

/**
 * Tarjeta Racional: el CSV «Reporte de operaciones» que Racional entrega para la DJ 1929.
 * Su lector está en src/services/inversionesExterior/lectores/racional.js
 */
const RacionalPage = ({ token, id_company }) => (
    <CargasFuente
        token={token}
        idCompany={id_company}
        fuente="racional"
        titulo="Racional"
        icono={<FaFileCsv />}
        extensiones=".csv"
        ayuda={(
            <>
                Sube el <strong>Reporte de operaciones</strong> (CSV) que Racional entrega para la DJ 1929; el Reporte
                de impuestos (Excel) no se sube. TAXI solo cambia la relación 99 por 9: lo demás queda como lo manda
                Racional, con avisos donde no calza con las instrucciones del SII. El archivo no se guarda.
            </>
        )}
    />
);

export default RacionalPage;
